document.addEventListener("DOMContentLoaded", function () {

    const tablaRemesas = document.getElementById("TablaRemesas");
    if (!tablaRemesas) return; // Solo en la página de remesas.

    // ---- Seleccionar todas las remesas pendientes ----
    const checkTodas = document.getElementById("checkTodas");
    if (checkTodas) {
        checkTodas.addEventListener("change", function () {
            document.querySelectorAll(".chk-remesa:not([disabled])").forEach((chk) => {
                chk.checked = checkTodas.checked;
            });
        });
    }

    // ---- Enviar remesas pendientes seleccionadas ----
    const btnEnviar = document.getElementById("btnEnviarRemesas");
    if (btnEnviar) {
        btnEnviar.addEventListener("click", function () {
            const ids = Array.from(document.querySelectorAll(".chk-remesa:checked"))
                .map((chk) => parseInt(chk.getAttribute("data-id"), 10));

            if (ids.length === 0) {
                alert("Selecciona al menos una remesa pendiente para enviar.");
                return;
            }
            if (!confirm(`¿Enviar ${ids.length} remesa(s) a AGV?`)) return;

            fetch("/api/remesas/enviar", {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ ids }),
                mensajeCargando: "Enviando remesas a AGV",
                detalleCargando: "La comunicación con AGV puede tardar unos segundos.",
                bloquearSalida: true,
            })
                .then((response) => response.json())
                .then((result) => {
                    if (!result.success) {
                        const msg = (result.errors || []).map((e) => e.message).join("\n");
                        alert("No se pudieron enviar las remesas:\n" + msg);
                        return;
                    }
                    const r = result.result;
                    alert(`Enviadas: ${r.enviadas} | Con error: ${r.errores}`);
                    if (typeof window.actualizarTablaRemesas === "function") {
                        window.actualizarTablaRemesas();
                    }
                })
                .catch((error) => {
                    console.error("Error al enviar remesas:", error);
                    alert("Ocurrió un error al enviar las remesas.");
                });
        });
    }

    // ---- Solicitar etiquetas (ROTULOSDATA) ----
    const fechaAGV = (valor) => (valor || "").replaceAll("-", ""); // AAAA-MM-DD -> AAAAMMDD

    function paramsEtiquetas() {
        return new URLSearchParams({
            fecIni: fechaAGV(document.getElementById("etqFecIni").value),
            fecFin: fechaAGV(document.getElementById("etqFecFin").value),
            remesaInicial: document.getElementById("etqRemesaIni").value,
            remesaFinal: document.getElementById("etqRemesaFin").value,
            division: document.getElementById("etqDivision").value,
        });
    }

    const btnConsultar = document.getElementById("btnConsultarEtiquetas");
    if (btnConsultar) {
        btnConsultar.addEventListener("click", function () {
            const params = paramsEtiquetas();
            const tbody = document.querySelector("#TablaEtiquetas tbody");
            fetch(`/api/remesas/etiquetas?${params.toString()}`, {
                method: "GET",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
            })
                .then((response) => response.json())
                .then((result) => {
                    tbody.innerHTML = "";
                    if (!result.success) {
                        const msg = (result.errors || []).map((e) => e.message).join("\n");
                        alert("No se pudieron consultar las etiquetas:\n" + msg);
                        return;
                    }
                    console.log(result);
                    const rotulos = result.result.rotulos || [];
                    if (rotulos.length === 0) {
                        tbody.innerHTML = `<tr class="no-data"><td colspan="6"><div class="cont-no-data">Sin rótulos para el rango indicado.</div></td></tr>`;
                        return;
                    }
                    rotulos.forEach((r) => {
                        const row = document.createElement("tr");
                        row.innerHTML = `
                            <td>${r.Remesa ?? ""}</td>
                            <td class="td-d">${r.Destinatario ?? ""}</td>
                            <td>${r.Ciudad ?? ""}</td>
                            <td class="td-d">${r.Direccion ?? ""}</td>
                            <td>${r.Unidades ?? ""}</td>
                            <td>${r.CodigoBarras ?? ""}</td>`;
                        tbody.appendChild(row);
                    });
                })
                .catch((error) => {
                    console.error("Error al consultar etiquetas:", error);
                    alert("Ocurrió un error al consultar las etiquetas.");
                });
        });
    }

    // ---- Abrir PDF de remesas (REMESASPDF) ----
    const btnPdf = document.getElementById("btnAbrirPdf");
    if (btnPdf) {
        btnPdf.addEventListener("click", function () {
            const params = paramsEtiquetas();
            window.open(`/api/remesas/pdf?${params.toString()}`, "_blank");
        });
    }
});
